import { openBlock as e, createElementBlock as o, createElementVNode as l } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}, n = /* @__PURE__ */ l("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M17.333 9A8.333 8.333 0 1 1 .667 9a8.333 8.333 0 0 1 16.666 0m-4.975-2.525a.625.625 0 0 1 0 .883l-4.166 4.167a.625.625 0 0 1-.884 0L5.642 9.858a.625.625 0 1 1 .883-.883L7.75 10.2l1.863-1.864 1.862-1.861a.625.625 0 0 1 .883 0",
  "clip-rule": "evenodd"
}, null, -1), r = [
  n
];
function c(d, a) {
  return e(), o("svg", t, [...r]);
}
const s = { render: c };
export {
  s as default,
  c as render
};
